import { persistor } from "store";
import * as api from "core-module/services/api";
import config from "config";
import store from "store";
import { dropApiData } from "../../core-module/services/api/actions";
import { dropAllData } from "../../core-module/data/actions";
import { dropIds } from "../../core-module/services/ids/actions";
import { isIosDevice, isNativeIosPlatform } from "../../deviceInfo";
import { signOutFromFirebase } from "../../firebaseAuth";
import { isFirebaseAuthMode } from "../../authMode";

let nativeLogoutPromise;

const logout = function () {
  if (!isNativeIosPlatform()) return performLogout();
  if (!nativeLogoutPromise) {
    nativeLogoutPromise = performLogout().catch((error) => {
      nativeLogoutPromise = undefined;
      throw error;
    });
  }
  return nativeLogoutPromise;
};

export const isNativeLogoutInProgress = () => Boolean(nativeLogoutPromise);

const performLogout = async function () {
  const shouldUseFirebaseLogin = isFirebaseAuthMode();
  const legacyLogoutUrl =
    config.AUTH.ADDRESS +
    config.AUTH.APP_PATH +
    "?route=logout&r=" +
    config.AUTH.REDIRECT_PARAM;

  api.get("me.1/logout").catch((e) => null);
  const firebaseSignOut = shouldUseFirebaseLogin
    ? signOutFromFirebase().catch((e) => null)
    : Promise.resolve();

  persistor.pause();
  await persistor.flush();
  await persistor.purge();

  const isIos = await isIosDevice();
  try {
    window.localStorage.removeItem("persist:root");
    if (!isIos) {
      if (shouldUseFirebaseLogin) {
        const legacyLogoutFrame = document.createElement("iframe");
        legacyLogoutFrame.src = legacyLogoutUrl;
        legacyLogoutFrame.style.display = "none";
        document.body.appendChild(legacyLogoutFrame);
        window.setTimeout(() => {
          window.location.replace(config.MYACCOUNT.APP_PATH + "/login");
        }, 500);
      } else {
        window.location.replace(legacyLogoutUrl);
      }
    }
  } catch (e) {
    console.log(e.message);
  }
  if (isIos) {
    store.dispatch(dropApiData());
    store.dispatch(dropAllData());
    store.dispatch(dropIds());
    await firebaseSignOut;
    // Reloading /will/logout remounts the confirmation screen and asks the
    // user to log out again. Go to the provider chooser instead.
    window.location.replace(config.MYACCOUNT.APP_PATH + "/login");
  }
};

export default logout;
